import React, { FC } from 'react'

import { ImageV2 } from '@Components/Image'
import { Asset } from '@Generated/graphql'

export const ImageVertical: FC<{ asset?: Asset, height?: number, index: number, title?: string, width?: number }> = ({
  asset,
  height = 78,
  index,
  title,
  width = 78,
}) => {
  if (!asset?.url) {
    return null
  }

  return (
    <div
      style={{
        position: 'relative',
        width,
        height,
        mixBlendMode: 'multiply',
      }}
    >
      <ImageV2
        alt={`${title || ''} - ${index + 1}`}
        cropRatio={asset.tags?.includes('look') ? '1:1' : undefined}
        layout="fill"
        loading={index <= 5 ? 'eager' : 'lazy'}
        objectFit="contain"
        objectPosition="center center"
        priority={index === 0}
        sizes={`${width}px`}
        src={asset.url}
      />
    </div>
  )
}
